import { observable, action } from 'mobx'
import { setCookie, getCookie } from '@hlj/hlj-utils'
import Api from '@api/rhinocerosAcademy'
import { getMerchantInfo } from '@util'
class Store {
  timer = null

  @observable visible = false
  @observable alreadyCSM = getCookie('alreadyCSM') == 1

  @action
  setQrcode = () => {
    setCookie('alreadyCSM', 1, 365)
    this.alreadyCSM = true
    this.visible = true
    let s = 3
    this.timer = setInterval(() => {
      if (s > 0) {
        s--
      } else {
        this.visible = false
        clearInterval(this.timer)
      }
    }, 1000)
  }

  @observable data = {}
  @action
  getInfo = async () => {
    const { id } = getMerchantInfo()
    const { success, data } = await Api.connectUs({ merchant_id: id })
    if (success) {
      this.data = data || {}
    }
  }
}
export default new Store()
